import { render } from "./RecentComments.vue?vue&type=template&id=f5962a9a"
import script from "./RecentComments.vue?vue&type=script&lang=js"
export * from "./RecentComments.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__